import { styled } from '@planne-software/uni/mui/material';

export const MonthCardButton = styled('button')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  justifyContent: 'flex-start',
  gap: '0.375rem',
  width: '5.625rem',
  minWidth: '5.625rem',
  maxWidth: '5.625rem',
  height: '6.4375rem',
  minHeight: '6.4375rem',
  maxHeight: '6.4375rem',
  flex: '0 0 auto',
  boxSizing: 'border-box',
  borderRadius: '0.25rem',
  backgroundColor: 'transparent',
  border: 'none',
  cursor: 'pointer',
  padding: '0.4375rem 0.5625rem 0.5rem 0.53125rem',
  transition: 'background-color 0.15s',
  '&:hover, &.Mui-selected': {
    backgroundColor: theme.tokens.colors['fill-color-neutral-softest']!,
  },
  '&:disabled': {
    cursor: 'default',
    opacity: 0.5,
  },
}));

export const MonthCardLabel = styled('span')(({ theme }) => ({
  ...theme.tokens.typography['text-sm-medium'],
  color: theme.tokens.colors['text-color-neutral-stronger']!,
  whiteSpace: 'nowrap',
  textTransform: 'capitalize',
}));
